{
  "version": 1,
  "asset_id": "3875eaa3-8f9d-4a69-adfa-d05c269fc822",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/3875eaa3-8f9d-4a69-adfa-d05c269fc822/monroya-logo-dark.png",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/3875eaa3-8f9d-4a69-adfa-d05c269fc822/monroya-logo-dark.png",
  "original_filename": "monroya-logo-dark.png",
  "size": 18105,
  "content_type": "image/png",
  "created_at": "2026-06-25T17:11:53Z"
}
